/**
 * 대한민국의 주요 공휴일 목록 (YYYY-MM-DD 형식)
 * @description
 * - 이 목록은 특정 연도에 대한 공휴일을 정의합니다.
 * - 매년 초, 또는 필요시 이 목록을 업데이트해야 합니다.
 * - 주말(토, 일)은 여기에 포함하지 않습니다.
 */
export const publicHolidays: string[] = [
  "2026-02-16",
  "2026-02-17",
  "2026-02-18",
  "2026-03-02",
  "2026-05-01",
  "2026-05-05",
  "2026-05-25",
  "2026-08-17",
];
